import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import {
  getClientStrategySchema,
  type ClientStrategySchemaParams,
} from "api/client-strategy-schema";

import { clientStrategySchemaKeys } from "hooks/api/query-keys";

import type { ClientStrategyCategoryDTOStrategyCategory } from "generated/schemas";

type UseQueryHookOptions<TQueryFnData, TData = TQueryFnData> = Omit<
  UseQueryOptions<TQueryFnData, Error, TData>,
  "queryKey" | "queryFn"
>;

export const useClientStrategySchema = <TData = unknown>(
  strategyCategory?: ClientStrategyCategoryDTOStrategyCategory,
  options?: UseQueryHookOptions<unknown, TData>,
) =>
  useQuery({
    queryKey: clientStrategySchemaKeys.schema(strategyCategory ?? ""),
    queryFn: () => {
      if (!strategyCategory) {
        throw new Error("Strategy category required for useClientStrategySchema queryFn");
      }

      return getClientStrategySchema({ strategyCategory });
    },
    ...options,
    enabled: Boolean(strategyCategory) && (options?.enabled ?? true),
  });

export type { ClientStrategySchemaParams };
